import React from 'react'
import PropTypes from 'prop-types'
import { setPropTypes, compose, withProps } from 'recompose'
import { inject, observer } from 'mobx-react'

import ImageOverlay from './ImageOverlay'
import { PhotoCarousel } from '../../../shared_components/PhotoCarousel'

const enhance = compose(
  inject('store'),
  withProps(({store}) => ({
    valueState: store.valueStateStore
  })),
  setPropTypes({
    valueState: PropTypes.object.isRequired
  }),
  observer
)

const CardCarousel = enhance(({
  containsVideoTour,
  containsZillow3dTour,
  closestOpenHouseDate,
  closestOpenHouseTime,
  isRecent,
  isActive,
  status,
  initialPhoto,
  listingId,
  highlights,
  listingClass,
  valueState,
  isEagerLoad= false
}) => {
  const listingType = listingClass === 'Rental' ? 'rentals' : 'sales'

  const firstPhoto = initialPhoto[0]

  return (
    <div className='CardDesktop-imageContainer'>
      {/* First image as a background to hide white screen while loading photos */}
      <div className='CardDesktop-aspectRatioCarousel'>
        <img
          src={firstPhoto?.webp}
          alt={firstPhoto?.webp || ''}
          loading={isEagerLoad? 'eager' : 'lazy'}
          fetchpriority={isEagerLoad? 'high' : 'auto'}
          width="600"
          height="360"
          className='CardDesktop-image'
        />
      </div>

      <ImageOverlay
        containsZillow3dTour={containsZillow3dTour}
        containsVideoTour={containsVideoTour}
        closestOpenHouseDate={closestOpenHouseDate}
        closestOpenHouseTime={closestOpenHouseTime}
        isRecent={isRecent}
        isActive={isActive}
        status={status}
        highlights={highlights}
      />

      <div className='CardDesktop-aspectRatioCarousel'>
        <PhotoCarousel
          listingId={listingId}
          listingType={listingType}
          firstPhoto={firstPhoto}
          getCardPhotos={valueState.getCardPhotos}
          isEagerLoad={isEagerLoad}
        />
      </div>
    </div>
  )
})

CardCarousel.propTypes = {
  containsVideoTour: PropTypes.bool,
  containsZillow3dTour: PropTypes.bool,
  closestOpenHouseDate: PropTypes.string,
  closestOpenHouseTime: PropTypes.string,
  isRecent: PropTypes.bool,
  status: PropTypes.string,
  listingClass: PropTypes.string,
  isActive: PropTypes.bool,
  highlights: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired
    })
  ),
  listingId: PropTypes.number,
  initialPhoto: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      jpeg: PropTypes.string.isRequired,
      webp: PropTypes.string.isRequired
    })
  ),
  isEagerLoad: PropTypes.bool
}

export default CardCarousel
